import axios from 'axios'
import store from '@/store'
import { Toast } from 'vant'
import router from "../router"
import { Loading } from 'vant'

const instance = axios.create({
	//baseURL:'http://card-san.com/api/',
	 baseURL:'http://haoka.zhnxu.com/api/',
	timeout: 30000  //30秒
})

const defaultOpt = {login: true}

function baseRequest(options) {

  const toast = Toast.loading({
    duration: 0, // 持续展示 toast
    forbidClick: true,
    message: options.message?options.message:'加载中',
  });


  const token = store.getters.token
  const headers = options.headers || {}
  if (token) {
    headers['token'] = token
    options.headers = headers
  }
  return new Promise((resolve, reject) => {
    instance(options).then(res => {
      const data = res.data || {}
      Toast.clear()
      if (data.code== -1) {
        store.dispatch('user/resetToken').then(() => {
            Toast({
              type:'fail',
              message: '请登录后操作',
              icon:'warning-o',
              duration:1000
            });
            setTimeout(function() {
            	router.push({ path: "/login" })
            }, 1000)
        })
      }else if (data.code === 1) {
        return resolve(data, res)
      } else if (data.code === 4) {
        return resolve(data, res)
      }else if (data.code === 9) {
        return resolve(data, res)
      }  else {
        Toast({
          type:'fail',
          message: data.msg,
          icon:'warning-o',
          duration:1500
        });

      }
    }).catch(message => reject({message}));
  })
}
/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ['post', 'put', 'patch', 'delete'].reduce((request, method) => {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(
      Object.assign({url, data, method}, defaultOpt, options)
    )
  }
  return request
}, {});

['get', 'head'].forEach(method => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(
      Object.assign({url, params, method}, defaultOpt, options)
    )
  }
})

export default request



// WEBPACK FOOTER //
// ./src/libs/request.js